import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Mailing Content',
  basePath: '/mailing-content',
  columns: [
    { key: 'publication_date', label: 'Publication Date', sortable: true },
    { key: 'mtype', label: 'Type', sortable: true },
    { key: 'title', label: 'Title', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'recipients', label: 'Recipients' },
    { key: 'error', label: 'Error', sortable: true },
    { key: 'mailing_groups', label: 'Groups',
      render: (/** @type {unknown} */ v) => {
        if (typeof v !== 'string' || v === '') return '';
        /** @type {Record<string, string>} */
        const map = { work: 'clients', reg: 'registry', order_tbl: 'shopping', forumemail: 'forum' };
        return v.split(',').map((w) => {
          const t = w.trim();
          return map[t] ?? t;
        }).join(', ');
      } },
    { key: 'sent_date_time', label: 'Sent', sortable: true },
    { key: 'user_name', label: 'User' },
  ],
  fields: [
    { key: 'title', label: 'Title', type: 'text', required: true },
    { key: 'status', label: 'Status', type: 'readonly' },
    { key: 'recipients', label: 'Recipients', type: 'readonly' },
    { key: 'error', label: 'Error', type: 'readonly' },
    { key: 'publication_date', label: 'Publication date', type: 'datetime' },
    { key: 'content', label: 'Mailing content', type: 'textarea' },
  ],
  rowActions: [
    { key: 'delete', label: 'Delete', variant: 'danger',
      confirm: 'Are you sure you want to remove this row?' },
  ],
  defaultSort: { field: 'publication_date', dir: 'desc' },
});
